/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { EndpointService } from './endpoint.service';
import { AdditionalParams, QueryParams, SpecificationQueryParamsEventModel } from '@irian-ro/abstract-resource';
import { map } from 'rxjs/operators';

/**
 * @deprecated Use the one from @irian-ro/abstract-resource
 */
export abstract class AbstractResourceService {
  public url;
  private endpointService: EndpointService | undefined = undefined;

  public constructor(endpointService: EndpointService, url: string) {
    this.endpointService = endpointService;
    this.url = url;
  }

  public resourceMapper(resource: unknown) {
    return resource;
  }

  public findOne(id: unknown) {
    return this.endpointService?.get(`${this.url}/${id}`);
  }

  public findAll(query?: SpecificationQueryParamsEventModel | undefined, additionalParams?: AdditionalParams[]) {
    const queryString = new QueryParams(query, additionalParams ? additionalParams : []).toString();
    return this.endpointService?.get(`${this.url}${queryString}`).pipe(map(this.resourceMapper));
  }

  public save(resource: unknown) {
    return this.endpointService?.save(`${this.url}`, resource);
  }

  public saveAll(resources: unknown[]) {
    return this.endpointService?.save(`${this.url}`, resources);
  }

  public update(uuid: unknown, resource: unknown) {
    return this.endpointService?.put(`${this.url}/${uuid}`, resource);
  }

  public remove(uuid: unknown) {
    return this.endpointService?.delete(`${this.url}/${uuid}`);
  }
}
